// extracted by mini-css-extract-plugin
module.exports = {"status":"status_status__yOK36","paid":"status_paid__TSm44","pending":"status_pending__kVr7N","processing":"status_processing__bDiBF","cancelled":"status_cancelled__kyft3"};